import React, { createContext, ReactNode, useContext, useEffect, useState } from 'react';
import isFunction from 'lodash/isFunction';

export type PacuV2State = Idle | AssignBed;

export interface Idle {
  type: 'Idle';
}

export interface AssignBed {
  type: 'AssignBed';
  patientId: any;
  patientPacuBed: any;
}

type PacuV2ContextValue = ReturnType<typeof useState<PacuV2State>>;

const PacuV2Context = createContext<PacuV2ContextValue>([{ type: 'Idle' }, () => {}]);

interface PacuV2StateProps {
  children: ReactNode | ((setState: PacuV2ContextValue[1]) => ReactNode);
}

export const PacuV2State = ({ children }: PacuV2StateProps) => {
  const value = useState<PacuV2State>({ type: 'Idle' });
  const [, setState] = value;

  useEffect(() => {
    const handleClick = () => setState({ type: 'Idle' });

    document.body.addEventListener('click', handleClick);

    return () => document.body.removeEventListener('click', handleClick);
  });

  return (
    <PacuV2Context.Provider value={value as any}>
      {isFunction(children) ? children(setState as any) : children}
    </PacuV2Context.Provider>
  );
};

export const usePacuV2State = () => useContext(PacuV2Context);
